import { inject, NgModule } from '@angular/core';
import { StateDeclaration, UIRouter } from '@uirouter/angular';
import { featureFlags } from '@utils/feature-flags';
import { AppInitializedEmitterService } from '@shared/services/app-initialized-emitter.service';
import { first } from 'rxjs/operators';

@NgModule({})
export class JobShareModule {
  private appInitializedEmitterSrv = inject(AppInitializedEmitterService);
  private router = inject(UIRouter);

  constructor() {
    this.appInitializedEmitterSrv
      .isAppInitialized()
      .pipe(first())
      .subscribe(() => this.addRoutesByFt());
  }

  private addRoutesByFt() {
    const jobShareListFT = featureFlags.isOn('Frontend.jobShareListRedesign');

    const states = jobShareListFT
      ? [
          {
            name: 'job-redirect',
            url: '/job/:jobId?st',
            onEnter: transition => {
              const jobId = transition.params().jobId;
              const st = transition.params().st;

              const queryParams = [];
              if (jobId) {
                queryParams.push(`jobId=${encodeURIComponent(jobId)}`);
              }
              if (st) {
                queryParams.push(`st=${encodeURIComponent(st)}`);
              }
              const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

              window.location.replace(`/r/${queryString}`);
            }
          },
          {
            name: 'job-list.**',
            url: '/r',
            loadChildren: () => import('../job-share-list/job-share-routing.module').then(m => m.JobShareRoutingModule)
          },
          {
            name: 'job-advert.**',
            url: '/jobs',
            loadChildren: () => import('../job-advert/job-advert.module').then(m => m.JobAdvertModule)
          }
        ]
      : [
          {
            name: 'job-advert.**',
            url: '/job',
            loadChildren: () => import('../job-advert/job-advert.module').then(m => m.JobAdvertModule)
          }
        ];

    states.forEach(state => {
      this.router.stateRegistry.register(state as StateDeclaration);
    });
  }
}
